import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import SearchBar from "./../../../component/atoms/input/searchBar";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import Checkbox from "./../../../component/atoms/input/checkbox";
import TableText from "./../../../component/atoms/text/table/tableText";
import PretendardText from "../../../component/atoms/text/pretendardText";
import Td from "./../../../component/atoms/layout/table/td";
import DetailBtn from "./../../../component/atoms/button/detailBtn";
import RedBtn from "./../../../component/atoms/button/redBtn";
import GrayBtn from "./../../../component/atoms/button/grayBtn";
import TableCount from "./../../../component/molecules/tableCount";
import Pagination from "./../../../component/molecules/pagination";
import Sidebar from "../../../component/organisms/sidebar";
import Header from "../../../component/organisms/header";
import Modal from "../../../component/templates/Modal";
import { route } from "./../../../router/route";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import scrollToTop from "../../../util/scrollToTop";
import BoardApi from "../../../api/board.api";
import Empty from "../../../component/molecules/empty";
import moment from "moment";

// sessionStorage 초기화
function sessionStorageInit() {
  sessionStorage.removeItem("sCheckedListStorage");
  const event = new Event("sessionStorageChange");
  window.dispatchEvent(event);
}

const OperationAsk = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.operation_ask)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [keyword, setKeyword] = useState("");
  const [activationFilter, setActivationFilter] = useState(true);

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("sCheckedListStorage");
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    setActivationFilter(
      searchParams.get("activation") === "false" ? false : true
    );

    getAskList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 카테고리 설정 팝업 관련 ---------- //
  const [buttonFilterOpen, setButtonFilterOpen] = useState(false);

  // ---------- 커뮤니티 관련 ---------- //
  const [askList, setAskList] = useState([]);

  const getAskList = async () => {
    try {
      const data = {
        page: Number(page),
        size: Number(pagination.size),
        boardPostType: "ASK",
      };

      if (keyword) {
        data.keyword = searchParams.get("keyword");
      }

      if (searchParams.get("activation") === "true") {
        data.answerStatus = "Active";
      } else if (searchParams.get("activation") === "false") {
        data.answerStatus = "Inactive";
      }

      const response = (await BoardApi.getListBoard(data)).data.data;

      const processedResponse = [...response.content].map((item, index) => {
        return {
          ...item,
          numbering: response.totalCount - (page - 1) * pagination.size - index,
        };
      });

      setAskList(processedResponse);
      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / 10),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const sessionStorageCheckedList = sessionStorage.getItem(
    "sCheckedListStorage"
  );
  const [checkedListStorage, setCheckedListStorage] = useState([]);
  const [buttonGroupOpen, setButtonGroupOpen] = useState(false);
  const [isAllCheck, setIsAllCheck] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setCheckedListStorage(
        sessionStorageCheckedList ? JSON.parse(sessionStorageCheckedList) : []
      );
    };

    window.addEventListener("sessionStorageChange", handleStorageChange);

    return () => {
      window.removeEventListener("sessionStorageChange", handleStorageChange);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    sessionStorage.setItem(
      "sCheckedListStorage",
      JSON.stringify(checkedListStorage)
    );
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (askList.length > 0) {
      const idsInArray1 = new Set(checkedListStorage.map((item) => item.id));

      const allIdsIncluded = askList.every((item) => idsInArray1.has(item.id));

      setIsAllCheck(allIdsIncluded);
    }

    if (checkedListStorage.length > 0) {
      setButtonGroupOpen(true);
    } else {
      setButtonGroupOpen(false);
    }
  }, [checkedListStorage, askList]); // eslint-disable-line react-hooks/exhaustive-deps

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteHandler = async () => {
    try {
      for (let i = 0; i < checkedListStorage.length; i++) {
        await BoardApi.deleteBoard(checkedListStorage[i].id);
      }
      sessionStorageInit();
      setDeleteModalOpen(false);
      toast(toastMsg.delete);
      getAskList();

      // navigate(
      //   `${route.operation_ask}?page=1&keyword=${keyword}&activation=${activationFilter}`
      // );
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 활성 상태 관련 ---------- //
  const [filterOpen, setFilterOpen] = useState(false);

  const activationChangeFunc = async (value) => {
    try {
      const data = {
        answerStatus: value,
      };

      for (let i = 0; i < checkedListStorage.length; i++) {
        await BoardApi.updateAnswerBoard(checkedListStorage[i].id, data);
      }

      sessionStorageInit();
      toast(toastMsg.update);
      getAskList();

      navigate(
        `${route.operation_ask}?page=1&keyword=${keyword}&activation=${activationFilter}`
      );
      setButtonFilterOpen(false);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>1:1 문의 내역 관리</TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount text={"문의"} count={pagination.totalCount} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"제목, 닉네임"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    sessionStorageInit();
                    navigate(
                      `${route.operation_ask}?page=1&keyword=${keyword}&activation=`
                    );
                  }
                }}
                onClick={() => {
                  sessionStorageInit();
                  navigate(
                    `${route.operation_ask}?page=1&keyword=${keyword}&activation=`
                  );
                }}
              />
              {/* <ExcelBtn /> */}
            </div>
          </TableTop>

          {/* 버튼 그룹 */}
          {buttonGroupOpen && isWriteAuthority && (
            <div
              style={{
                width: "100%",
                height: 49,
                display: "flex",
                gap: 12,
              }}
            >
              <div
                style={{
                  height: "fit-content",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  position: "relative",
                }}
              >
                <GrayBtn
                  onClick={() => {
                    setButtonFilterOpen(!buttonFilterOpen);
                  }}
                >
                  상태 변경
                </GrayBtn>
                {buttonFilterOpen && (
                  <FilterWrapper
                    style={{
                      width: 115,
                      top: 36,
                    }}
                  >
                    <FilterText
                      onClick={() => {
                        activationChangeFunc(true);
                      }}
                    >
                      답변완료
                    </FilterText>
                    <FilterText
                      onClick={() => {
                        activationChangeFunc(false);
                      }}
                    >
                      미답변
                    </FilterText>
                  </FilterWrapper>
                )}
              </div>
              <RedBtn
                style={{
                  backgroundColor: "#272829",
                }}
                onClick={() => {
                  setDeleteModalOpen(true);
                }}
              >
                내역 삭제
              </RedBtn>
            </div>
          )}

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="56px" />
              {/* No */}
              <col width="40px" />
              {/* 제목 */}
              <col width="348px" />
              {/* 닉네임 */}
              <col width="136px" />
              {/* 등록일 */}
              <col width="169px" />
              {/* 상태 */}
              <col width="203px" />
              {/* 보기 */}
              <col width="92px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // 배열 병합 및 중복 제거
                        const mergedArray = [
                          ...askList,
                          ...checkedListStorage,
                        ].reduce((acc, current) => {
                          const existingItem = acc.find(
                            (item) => item.id === current.id
                          );
                          if (!existingItem) {
                            acc.push(current);
                          }
                          return acc;
                        }, []);

                        setCheckedListStorage(mergedArray);
                      } else {
                        const idsToExclude = new Set(
                          askList.map((item) => item.id)
                        );
                        const filteredArray = checkedListStorage.filter(
                          (item) => !idsToExclude.has(item.id)
                        );

                        setCheckedListStorage(filteredArray);
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    No
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    제목
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    닉네임
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    등록일
                  </TableText>
                </Th>
                <Th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      상태
                    </TableText>
                    <img
                      className={filterOpen === true ? "rotate" : "rotate-back"}
                      src="/assets/admin/icons/ico_arrow_down.svg"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setFilterOpen(!filterOpen);
                      }}
                      alt="필터 펼치기/접기"
                    />
                    {filterOpen && (
                      <FilterWrapper>
                        <FilterTextWrapper>
                          <FilterText
                            onClick={() => {
                              navigate(
                                `${
                                  route.operation_ask
                                }?page=1&keyword=${keyword}&activation=${true}`
                              );
                              setActivationFilter(false);
                            }}
                          >
                            답변완료
                            {activationFilter ? (
                              <img
                                src="/assets/admin/icons/ico_selectbox_checked.svg"
                                alt="선택됨"
                              />
                            ) : null}
                          </FilterText>
                        </FilterTextWrapper>
                        <FilterText
                          onClick={() => {
                            navigate(
                              `${
                                route.operation_ask
                              }?page=1&keyword=${keyword}&activation=${false}`
                            );
                            setActivationFilter(false);
                          }}
                        >
                          미답변
                          {activationFilter ? null : (
                            <img
                              src="/assets/admin/icons/ico_selectbox_checked.svg"
                              alt="선택됨"
                            />
                          )}
                        </FilterText>
                      </FilterWrapper>
                    )}
                  </div>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    보기
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {askList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "59px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={checkedListStorage.some(
                          (item02) => item02.id === item.id
                        )}
                        onChange={() => {
                          if (
                            checkedListStorage.length > 0 &&
                            checkedListStorage.some(
                              (item02) => item02.id === item.id
                            )
                          ) {
                            let temp = checkedListStorage.filter(
                              (item02) => item02.id !== item.id
                            );
                            setCheckedListStorage(temp);
                          } else {
                            setCheckedListStorage([
                              item,
                              ...checkedListStorage,
                            ]);
                          }
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText>{item.numbering}</TableText>
                    </Td>
                    {/* 제목 */}
                    <Td>
                      <TableText
                        style={{
                          maxWidth: "248px",
                        }}
                      >
                        {item.title}
                      </TableText>
                    </Td>
                    {/* 닉네임 */}
                    <Td>
                      <TableText
                        style={{
                          maxWidth: "98px",
                        }}
                      >
                        {item.member.nickname}
                      </TableText>
                    </Td>
                    {/* 등록일 */}
                    <Td>
                      <TableText>
                        {moment(item.createdAt).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                    {/* 상태 */}
                    <Td>
                      <TableText
                        style={{
                          color: `${item.answerStatus ? "#aaa" : "#cf6679"}`,
                        }}
                      >
                        {item.answerStatus ? "답변완료" : "미답변"}
                      </TableText>
                    </Td>
                    {/* 보기 */}
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(`${route.operation_ask_detail}/${item.id}`);
                          scrollToTop();
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>

          {askList.length > 0 ? null : <Empty />}

          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.operation_ask}
            queryString={`keyword=${keyword}&activation=${activationFilter}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {/* 삭제 모달 */}
      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteHandler}
        />
      )}
    </>
  );
};

export default OperationAsk;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;

const FilterTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  gap: 1px;
`;

const FilterText = styled(PretendardText).attrs((props) => {})`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  color: #aaa;
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background: #313233;
  }
`;
